export default {
  edit_selection: 'Edytuj wybór',
};
